const initialState = {
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const resetState = {
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const mallUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETMALLUSERSEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETMALLUSERSEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETMALLUSERPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETMALLUSERTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETMALLUSERISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETMALLUSERRESET':
      return {
        ...state,
        ...resetState,
      };

    default:
      return state;
  }
};

export default mallUserReducer;
